import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Timestamp from "components/Timestamp";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectsTableCreatedAtCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const copyAction = useCellCopyAction({
    text: makeTimestampToCopy(intentProject.createdAt),
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <Timestamp timestamp={intentProject.createdAt} />
    </TableSimpleCell>
  );
};

export default IntentProjectsTableCreatedAtCell;
